import { styled } from 'solid-styled-components';
import theme, { ColorName, palette } from '../../style/theme';

export const StyledExpandableWrapper = styled.div`
    margin-top: 1rem;
    margin-bottom: 2rem;
`;

export const StyledExpandableContentInner = styled.div<{ bgColor: ColorName }>`
    display: flex;
    flex-direction: column;

    background-color: ${p => palette[p.bgColor]};
    padding: ${theme.spacing.m} ${theme.spacing.xl};
    padding-top: 1rem;
    border-bottom-left-radius: 1.43rem;
    border-bottom-right-radius: 1.43rem;

    ${theme.containerQueries.mobileMax} {
        border-bottom-left-radius: 1.1rem;
        border-bottom-right-radius: 1.1rem;
        padding: ${theme.spacing.xs};
    }
`;

